// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../Assets/fonts/Dax-Pro-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../Assets/Images/aboutus-hreo-bg.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --font-family: daxplinepro;
  --primary-green: #5bbf1479;
  --primary-orange: #eaad11;

  --color-white: #fff;
  --dark--green: #013e01;

  --color-grey: #eee;
  /* --box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1); */
}


html {
  font-size: 10px;
  width: 100vw;
}

body {
  font-family: var(--font-family);
  /* width: 100vw; */
  
}

section {
  width: 100%;
  padding: 8rem 0;
}


.container {
  max-width: 1000px;
  margin: 0 auto;
  padding: 0 20px;
}

/* UTILITY CLASSES */

/* Flex */
.--flex-center {
  display: flex;
  justify-content: center;
  align-items: center;
}
.--flex-start {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
}
.--flex-end {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
.--flex-between {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.--dir-column {
  flex-direction: column;
}

.--flex-dir-column {
  display: flex;
}

.--align-center {
  display: flex;
  align-items: center;
}

.--100vh {
  height: 100vh;
}

.--mh-100vh {
  min-height: 100vh;
}

/* Grid */
.--grid-15 {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(15rem, 1fr));
  row-gap: 1rem;
  column-gap: 1rem;
}
.--grid-25 {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  justify-content: center;
  align-items: center;
  
}

/* Center All */
.--center-all {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 100%;
  margin: auto;
  /* text-align: center;*/
}


.--text-xl {
  font-size: 4.5rem;
}
.--text-lg {
  font-size: 4rem;
}

.--text-md {
  font-size: 3rem;
}

.--text-sm {
  font-size: 1.2rem;
  font-weight: 300;
}

.--text-p {
  font-size: 1.5rem;
  font-weight: 300;
  line-height: 1.3;
  color: var(--color-dark);
}

.--fw-bold {
  font-weight: 600;
}
.--fw-thin {
  font-weight: 200;
}

/* Text Color */
.--text-light {
  color: #fff;
}

.--color-primary {
  color: #007bff;
}
.--color-danger {
  color: orangered;
}
.--color-success {
  color: #28a745;
}

.--color-white {
  color: #fff;
}

/* Center Text */
.--text-center {
  text-align: center;
}

/* Card */
.--card {
  border: 1px solid transparent;
  border-radius: 5px;
  box-shadow: var(--box-shadow);
  overflow: hidden;
}

/* Margin */
.--m {
  margin: 1rem;
}
.--ml {
  margin-left: 1rem;
}
.--mr {
  margin-right: 1rem;
}

.--mb {
  margin-bottom: 1rem;
}

.--my {
  margin: 1rem 0;
}
.--mx {
  margin: 0 1rem;
}

.--m2 {
  margin: 2rem;
}

.--ml2 {
  margin-left: 2rem;
}
.--mr2 {
  margin-right: 2rem;
}

.--mb2 {
  margin-bottom: 2rem;
}

.--my2 {
  margin: 2rem 0;
}

.--mx2 {
  margin: 0 2rem;
}

/* Padding */
.--p {
  padding: 1rem;
}
.--p2 {
  padding: 2rem;
}
.--py {
  padding: 1rem 0;
}
.--py2 {
  padding: 2rem 0;
}
.--px {
  padding: 0 1rem;
}
.--px2 {
  padding: 0 2rem;
}

.--btn {
  font-size: 1.6rem;
  font-weight: 400;
  padding: 6px 8px;
  margin: 0 5px 0 0;
  border: 1px solid transparent;
  border-radius: 3px;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: all 0.3s;
}

.--btn:hover {
  transform: translateY(-2px);
}

.--btn-lg {
  padding: 8px 10px;
}

.--btn-block {
  width: 100%;
}

.--btn-primary {
  color: #fff;
  background: #007bff;
}
.--btn-secondary {
  color: #fff;
  border: 1px solid #fff;
  background: transparent;
}
.--btn-danger {
  color: #fff;
  background: orangered;
}

.--btn-success {
  color: #fff;
  background: #28a745;
}

/* Background */
.--bg-light {
  background: #fff;
}
.--bg-dark {
  background: var(--color-dark);
}
.--bg-primary {
  background: var(--color-primary);
}
.--bg-success {
  background: var(--color-success);
}
.--bg-grey {
  background: var(--color-grey);
}

.--form-control {
  font-size: 1.6rem;
  font-weight: 300;
}

.--form-control > * {
  margin: 5px 0;
}

.--form-control input {
  font-size: 1.6rem;
  font-weight: 300;
  padding: 8px 1rem;
  border: 1px solid #777;
  border-radius: 3px;
  outline: none;
}
.--form-control select {
  font-size: 1.4rem;
  font-weight: 400;
  padding: 8px 1rem;
  border: 1px solid #777;
  border-radius: 3px;
}

.--form-control label {
  font-size: 1.6rem;
  font-weight: 400;
  display: inline-block;
  min-width: 7rem;
  color: var(--color-dark);
  margin-right: 1rem;
}





.--block {
  display: block;
}
.--inline-block {
  display: inline-block;
}

.--width-100 {
  width: 100%;
}

.--width-500px {
  width: 500px;
}

.--line {
  position: relative;
}
.--line::after {
  content: "";
  position: absolute;
  left: 50%;
  bottom: -5px;
  transform: translateX(-50%);
  width: 5rem;
  height: 3px;
  margin-bottom: 1rem;

  background: rgb(217, 8, 170);
  background: linear-gradient(
    135deg,
    rgba(163, 1, 191, 1) 44%,
    rgba(217, 8, 170, 1) 57%
  );
}

.--list-style-none {
  list-style: none;
}

.--profile-img {
  width: 6rem;
  height: 6rem;
  border: 1px solid #ccc;
  border-radius: 50%;
}

/* a {
  font-size: 1rem;
  color: #0F0F0F;
  text-decoration: none;
  transition: all 0.2s;
} */

@font-face {
  font-family: daxplinepro;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

/* a:hover {
  color: var(--color-dark);
  font-size: 1.5rem;
} */

/* Start here */
.products {
  background-color: var(--dark--green);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  height: 100%;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: 80% 26%;
  padding: 4rem 4rem 0rem 4rem;
  /* position: relative;
  z-index: -1; */
}


.overlay {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: -1;
  background-color: rgba(1, 34, 9, 0.641);
}

.products p {
  color: var(--primary-orange);
  font-size: 0.9rem;
}

.ourProducts h3 {
  font-size: 3.5rem;
}
.ourProducts {
  display: flex;
  justify-content: space-between;
}
.ourProducts h6 {
  font-size: 1.5rem;
  width: 50%;
}
.ourProducts span {
  display: block;
}

.card {
  font-family: daxplinepro;
  background-color: var(--primary-green);
  border-radius: 0.7rem;
  padding: 6rem 4rem;
  color: var(--color-white);
  margin: 2rem;
  /* margin-left: 4rem; */
  /* width: 90%; */
}

.paragraph p {
  font-size: 1.5rem;
  font-weight: 200;
  color: white;
  text-align: center;
  padding: 2rem;
}

.paragraph span {
  display: block;
}
/* projects and products */
.projects {
  
  padding: 4rem 2rem;
  color: var(--color-white);
  font-size: 1.3rem;
  gap: 30px;
}
.adverse {
  background-color: #0fdc0f;
  color: black;
  display: flex;
  justify-content: space-between;
  border-radius: 2rem;
  height: 222px;
  /* z-index: 999; */
}

.logo {
  z-index: 999;
  width: 100;
  margin-top: 1.5rem;
  padding: 1rem;
}
.adversediv {
  background-color: white;
  width: 100%;
  padding: 1rem;
  border-radius: 1rem;
}

.adversediv_p{
  height: 100px;
  padding-top: 10px;
  font-size: 14px !important;
  font-weight: 400 !important;
  line-height: 21px !important;
  color: #000 !important;
}

button {
  background-color: #0fdc0f;
  padding: 1rem;
  border: 1px solid transparent;
  margin: 2rem 0rem;
  color: white;
  width: 80%;
  border-radius: 2rem;
  font-size: 1.5rem;
  cursor: pointer;
}

/* APPRAISE CARD */
.Appraise {
  background-color: red;
}

/* VatDOc Card */
.VatDoc {
  background-color: var(--primary-orange);
}
/* VatDoc */
.WeApprove {
  background-color: red;
}
.ChargePlus {
  background-color: var(--primary-orange);
}
.Verifyer {
  background-color: var(--primary-orange);
}
.room {
  background-color: var(--primary-orange);
}

/* Epertise Section */
/* Epertise Section */
/* Epertise Section */
.expertise {
  background-color: var(--dark--green);
  width: 100%;
  color: white;
  height: auto !important;
  /* padding: 2rem; */
}
.expertisecontainer {
  display: flex;
  color: white;
  padding: 1rem;
  gap: 6rem;
}

.expertiseparagraph {
  width: 25% !important;
  position: relative;
  text-transform: capitalize;
  margin-bottom: 1rem;

}

.expertiseparagraph p {
  font-size: 1.2rem !important;
}

.expertiseparagraph h3{
  font-size: 2.7rem !important;
  margin-top: .8rem;
  margin-bottom: 1.2rem;
}
.colors::after {
  position: absolute;
  content: "";
  bottom: 40;
  left: 0;
  width: 65%;
  border-radius: 2rem;
  height: 1%;
  background-image: linear-gradient(
    to left,
    #eaad11,
    #d6b700,
    #bec100,
    #a1ca00,
    #7dd200,
    #7dd200,
    #7dd200,
    #7dd200,
    #a1ca00,
    #bec100,
    #d6b700,
    #eaad11
  );
}

.professional {
  display: flex;
  gap: 2rem;
}

.tech2{
 font-size: 3rem;
}
.sketch{
  width: 8%;
  padding-right: .7rem;
}
.tech2 p{
  color: white;
  font-size: 1.5rem;
  margin-top: 1rem;
  flex-wrap: wrap;
  margin-left: 4rem;

}
.tech2 p span {
  display: block;
}

.lady_techie{
  border-radius: 15px;
}

/* Mobile screens */
@media screen and (max-width: 1050px) {

  .adversediv_p{
    height: 115px;
    font-size: 12px !important;
    line-height: 20px !important;
  }

  button {
    width: 90%;
  }

  .expertisecontainer {
    gap: 3rem;
    
  }

  .expertiseparagraph {
    width: 30% !important;
  }

  .expertiseparagraph h3{
    font-size: 2.4rem !important;
  }

  .lady_techie{
    width: 200px;
    height: 350px;
    object-fit: cover;
    border-radius: 15px;
  }

  .man_techie{
    width: 350px;
  }

}


@media screen and (max-width: 900px) {
  .--grid-25 {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    justify-content: center;
    align-items: center;
  } 
  
  .adversediv_p{
    height: 110px;
  }

  .expertisecontainer {
    gap: 1rem;
    
  }

  .expertiseparagraph {
    width: 35% !important;
  }

  .expertiseparagraph h3{
    font-size: 2rem !important;
  }

  .lady_techie{
    width: 150px;
    height: 350px;
  }

  .man_techie{
    width: 220px;
  }

  .tech2{
    font-size: 1.6rem;
   }
   .sketch{
     width: 13%;
     padding-right: 0.8rem;
     margin-top: 10px;
   }

   .sketch_span{
    font-size: 20px!important;
   }

   .tech2 p{
     color: white;
     font-size: 1.5rem;
     margin-top: 1rem;
     flex-wrap: wrap;
     margin-left: 2.6rem;
   
   }


}


@media screen and (max-width: 500px) {

  .card {
    padding: 6rem 2.5rem;
  }

  .products {
    padding: 3rem 2rem;
    background-position: center;
  }

  .ourProducts {
    flex-direction: column;
  }
  .card{
    margin-left: 0;
    width: 100%;
  }
  .card p{
    width: 100%;
  }
  
  .ourProducts h3 {
    width: 100%;
    font-size: 2.7rem;
    padding: 20px 0;
  }
  .ourProducts h6 {
    width: 100%;
    font-size: 1.3rem;
  }

  .projects{
    padding: 1rem 0rem;
  }

  button {
    padding: 0.8rem 0;
  }

  .adverse{
    width: 100%;
  }
  

  .--grid-25 {
    display: grid;
    grid-template-columns: repeat(1, 1fr);
  }

  .expertisecontainer{
    flex-direction: column;
   
  }
  .expertiseparagraph{
    width: 100% !important;
  }
  
  .expertiseparagraph h3 {
    width: 100%;
  }

  .professional{
    flex-direction: column;
    align-items: center;
    width: 100%;

  }

  .techie1{ 
    margin-top: 2rem;
    width: 100%;
    display: flex !important;
  }


  .lady_techie{
    display: none !important;
  }

  .man_techie{
    width: 100% !important;
  }

  .sketch{
    display: inline-block !important;
    width: 8% !important;
  }
 
  .adversediv{
    padding: 1rem;
  }

  .colors::after{
    height: 10%;
    width: 75% !important;
  }

  .tech2 p{
    margin-left: 3rem !important;
    width: 280px !important;
  }
}

@media screen and (max-width: 380px) {
  .ourProducts h3 {
    font-size: 2.5rem;
  }
  .ourProducts h6 {
    font-size: 1.1rem;
  }
}

@media screen and (max-width: 330px) {

  .ourProducts h3 {
    font-size: 2.3rem;
  }
  .ourProducts h6 {
    font-size: 1rem;
  }

  .adversediv_p{
    font-size: 12px !important;
    font-weight: 400 !important;
    line-height: 18px !important;
    height: 120px;
  }

  button {
    width: 90%;
  }

  .sketch{
    /* display: inline-block !important; */
    width: 10% !important;
  }

  .tech2 p{
    margin-left: 3rem !important;
    width: 220px !important;
  }
}

`, "",{"version":3,"sources":["webpack://./src/styles/Products.css"],"names":[],"mappings":"AAAA;EACE,0BAA0B;EAC1B,0BAA0B;EAC1B,yBAAyB;;EAEzB,mBAAmB;EACnB,sBAAsB;;EAEtB,kBAAkB;EAClB,iDAAiD;AACnD;;;AAGA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,+BAA+B;EAC/B,kBAAkB;;AAEpB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;;AAGA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA,oBAAoB;;AAEpB,SAAS;AACT;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,2BAA2B;EAC3B,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,iBAAiB;AACnB;;AAEA,SAAS;AACT;EACE,aAAa;EACb,2DAA2D;EAC3D,aAAa;EACb,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,qCAAqC;EACrC,uBAAuB;EACvB,mBAAmB;;AAErB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,uBAAuB;AACzB;;;AAGA;EACE,iBAAiB;AACnB;AACA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;;AAEA,eAAe;AACf;EACE,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;AACpB;;AAEA,SAAS;AACT;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA,WAAW;AACX;EACE,YAAY;AACd;AACA;EACE,iBAAiB;AACnB;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,iBAAiB;AACnB;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,YAAY;AACZ;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;EAC7B,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,sBAAsB;EACtB,uBAAuB;AACzB;AACA;EACE,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA,eAAe;AACf;EACE,gBAAgB;AAClB;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,gCAAgC;AAClC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,6BAA6B;AAC/B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;AACf;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;EACf,wBAAwB;EACxB,kBAAkB;AACpB;;;;;;AAMA;EACE,cAAc;AAChB;AACA;EACE,qBAAqB;AACvB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,YAAY;EACZ,2BAA2B;EAC3B,WAAW;EACX,WAAW;EACX,mBAAmB;;EAEnB,4BAA4B;EAC5B;;;;GAIC;AACH;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;;;;;GAKG;;AAEH;EACE,wBAAwB;EACxB,4CAA6C;AAC/C;;AAEA;;;GAGG;;AAEH,eAAe;AACf;EACE,oCAAoC;EACpC,yDAA2D;EAC3D,YAAY;EACZ,4BAA4B;EAC5B,sBAAsB;EACtB,4BAA4B;EAC5B,4BAA4B;EAC5B;gBACc;AAChB;;;AAGA;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,WAAW;EACX,uCAAuC;AACzC;;AAEA;EACE,4BAA4B;EAC5B,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,8BAA8B;AAChC;AACA;EACE,iBAAiB;EACjB,UAAU;AACZ;AACA;EACE,cAAc;AAChB;;AAEA;EACE,wBAAwB;EACxB,sCAAsC;EACtC,qBAAqB;EACrB,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;AACA,0BAA0B;AAC1B;;EAEE,kBAAkB;EAClB,yBAAyB;EACzB,iBAAiB;EACjB,SAAS;AACX;AACA;EACE,yBAAyB;EACzB,YAAY;EACZ,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,kBAAkB;EAClB,aAAa;AACf;AACA;EACE,uBAAuB;EACvB,WAAW;EACX,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,0BAA0B;EAC1B,2BAA2B;EAC3B,4BAA4B;EAC5B,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,6BAA6B;EAC7B,iBAAiB;EACjB,YAAY;EACZ,UAAU;EACV,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;AACjB;;AAEA,kBAAkB;AAClB;EACE,qBAAqB;AACvB;;AAEA,gBAAgB;AAChB;EACE,uCAAuC;AACzC;AACA,WAAW;AACX;EACE,qBAAqB;AACvB;AACA;EACE,uCAAuC;AACzC;AACA;EACE,uCAAuC;AACzC;AACA;EACE,uCAAuC;AACzC;;AAEA,qBAAqB;AACrB,qBAAqB;AACrB,qBAAqB;AACrB;EACE,oCAAoC;EACpC,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,YAAY;EACZ,aAAa;EACb,SAAS;AACX;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,0BAA0B;EAC1B,mBAAmB;;AAErB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;EAC5B,iBAAiB;EACjB,qBAAqB;AACvB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,OAAO;EACP,UAAU;EACV,mBAAmB;EACnB,UAAU;EACV;;;;;;;;;;;;;;GAcC;AACH;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;CACC,eAAe;AAChB;AACA;EACE,SAAS;EACT,oBAAoB;AACtB;AACA;EACE,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;;AAEnB;AACA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,mBAAmB;AACnB;;EAEE;IACE,aAAa;IACb,0BAA0B;IAC1B,4BAA4B;EAC9B;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,SAAS;;EAEX;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,YAAY;IACZ,aAAa;IACb,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,YAAY;EACd;;AAEF;;;AAGA;EACE;IACE,aAAa;IACb,qCAAqC;IACrC,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,SAAS;;EAEX;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,iBAAiB;GAClB;GACA;KACE,UAAU;KACV,qBAAqB;KACrB,gBAAgB;GAClB;;GAEA;IACC,yBAAyB;GAC1B;;GAEA;KACE,YAAY;KACZ,iBAAiB;KACjB,gBAAgB;KAChB,eAAe;KACf,mBAAmB;;GAErB;;;AAGH;;;AAGA;;EAEE;IACE,oBAAoB;EACtB;;EAEA;IACE,kBAAkB;IAClB,2BAA2B;EAC7B;;EAEA;IACE,sBAAsB;EACxB;EACA;IACE,cAAc;IACd,WAAW;EACb;EACA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;IACX,iBAAiB;IACjB,eAAe;EACjB;EACA;IACE,WAAW;IACX,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,WAAW;EACb;;;EAGA;IACE,aAAa;IACb,qCAAqC;EACvC;;EAEA;IACE,sBAAsB;;EAExB;EACA;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;IACnB,WAAW;;EAEb;;EAEA;IACE,gBAAgB;IAChB,WAAW;IACX,wBAAwB;EAC1B;;;EAGA;IACE,wBAAwB;EAC1B;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,gCAAgC;IAChC,oBAAoB;EACtB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,WAAW;IACX,qBAAqB;EACvB;;EAEA;IACE,4BAA4B;IAC5B,uBAAuB;EACzB;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;AACF;;AAEA;;EAEE;IACE,iBAAiB;EACnB;EACA;IACE,eAAe;EACjB;;EAEA;IACE,0BAA0B;IAC1B,2BAA2B;IAC3B,4BAA4B;IAC5B,aAAa;EACf;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,sCAAsC;IACtC,qBAAqB;EACvB;;EAEA;IACE,4BAA4B;IAC5B,uBAAuB;EACzB;AACF","sourcesContent":[":root {\n  --font-family: daxplinepro;\n  --primary-green: #5bbf1479;\n  --primary-orange: #eaad11;\n\n  --color-white: #fff;\n  --dark--green: #013e01;\n\n  --color-grey: #eee;\n  /* --box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1); */\n}\n\n\nhtml {\n  font-size: 10px;\n  width: 100vw;\n}\n\nbody {\n  font-family: var(--font-family);\n  /* width: 100vw; */\n  \n}\n\nsection {\n  width: 100%;\n  padding: 8rem 0;\n}\n\n\n.container {\n  max-width: 1000px;\n  margin: 0 auto;\n  padding: 0 20px;\n}\n\n/* UTILITY CLASSES */\n\n/* Flex */\n.--flex-center {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.--flex-start {\n  display: flex;\n  justify-content: flex-start;\n  align-items: flex-start;\n}\n.--flex-end {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n}\n.--flex-between {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.--dir-column {\n  flex-direction: column;\n}\n\n.--flex-dir-column {\n  display: flex;\n}\n\n.--align-center {\n  display: flex;\n  align-items: center;\n}\n\n.--100vh {\n  height: 100vh;\n}\n\n.--mh-100vh {\n  min-height: 100vh;\n}\n\n/* Grid */\n.--grid-15 {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(15rem, 1fr));\n  row-gap: 1rem;\n  column-gap: 1rem;\n}\n.--grid-25 {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  justify-content: center;\n  align-items: center;\n  \n}\n\n/* Center All */\n.--center-all {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n  width: 100%;\n  margin: auto;\n  /* text-align: center;*/\n}\n\n\n.--text-xl {\n  font-size: 4.5rem;\n}\n.--text-lg {\n  font-size: 4rem;\n}\n\n.--text-md {\n  font-size: 3rem;\n}\n\n.--text-sm {\n  font-size: 1.2rem;\n  font-weight: 300;\n}\n\n.--text-p {\n  font-size: 1.5rem;\n  font-weight: 300;\n  line-height: 1.3;\n  color: var(--color-dark);\n}\n\n.--fw-bold {\n  font-weight: 600;\n}\n.--fw-thin {\n  font-weight: 200;\n}\n\n/* Text Color */\n.--text-light {\n  color: #fff;\n}\n\n.--color-primary {\n  color: #007bff;\n}\n.--color-danger {\n  color: orangered;\n}\n.--color-success {\n  color: #28a745;\n}\n\n.--color-white {\n  color: #fff;\n}\n\n/* Center Text */\n.--text-center {\n  text-align: center;\n}\n\n/* Card */\n.--card {\n  border: 1px solid transparent;\n  border-radius: 5px;\n  box-shadow: var(--box-shadow);\n  overflow: hidden;\n}\n\n/* Margin */\n.--m {\n  margin: 1rem;\n}\n.--ml {\n  margin-left: 1rem;\n}\n.--mr {\n  margin-right: 1rem;\n}\n\n.--mb {\n  margin-bottom: 1rem;\n}\n\n.--my {\n  margin: 1rem 0;\n}\n.--mx {\n  margin: 0 1rem;\n}\n\n.--m2 {\n  margin: 2rem;\n}\n\n.--ml2 {\n  margin-left: 2rem;\n}\n.--mr2 {\n  margin-right: 2rem;\n}\n\n.--mb2 {\n  margin-bottom: 2rem;\n}\n\n.--my2 {\n  margin: 2rem 0;\n}\n\n.--mx2 {\n  margin: 0 2rem;\n}\n\n/* Padding */\n.--p {\n  padding: 1rem;\n}\n.--p2 {\n  padding: 2rem;\n}\n.--py {\n  padding: 1rem 0;\n}\n.--py2 {\n  padding: 2rem 0;\n}\n.--px {\n  padding: 0 1rem;\n}\n.--px2 {\n  padding: 0 2rem;\n}\n\n.--btn {\n  font-size: 1.6rem;\n  font-weight: 400;\n  padding: 6px 8px;\n  margin: 0 5px 0 0;\n  border: 1px solid transparent;\n  border-radius: 3px;\n  cursor: pointer;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  transition: all 0.3s;\n}\n\n.--btn:hover {\n  transform: translateY(-2px);\n}\n\n.--btn-lg {\n  padding: 8px 10px;\n}\n\n.--btn-block {\n  width: 100%;\n}\n\n.--btn-primary {\n  color: #fff;\n  background: #007bff;\n}\n.--btn-secondary {\n  color: #fff;\n  border: 1px solid #fff;\n  background: transparent;\n}\n.--btn-danger {\n  color: #fff;\n  background: orangered;\n}\n\n.--btn-success {\n  color: #fff;\n  background: #28a745;\n}\n\n/* Background */\n.--bg-light {\n  background: #fff;\n}\n.--bg-dark {\n  background: var(--color-dark);\n}\n.--bg-primary {\n  background: var(--color-primary);\n}\n.--bg-success {\n  background: var(--color-success);\n}\n.--bg-grey {\n  background: var(--color-grey);\n}\n\n.--form-control {\n  font-size: 1.6rem;\n  font-weight: 300;\n}\n\n.--form-control > * {\n  margin: 5px 0;\n}\n\n.--form-control input {\n  font-size: 1.6rem;\n  font-weight: 300;\n  padding: 8px 1rem;\n  border: 1px solid #777;\n  border-radius: 3px;\n  outline: none;\n}\n.--form-control select {\n  font-size: 1.4rem;\n  font-weight: 400;\n  padding: 8px 1rem;\n  border: 1px solid #777;\n  border-radius: 3px;\n}\n\n.--form-control label {\n  font-size: 1.6rem;\n  font-weight: 400;\n  display: inline-block;\n  min-width: 7rem;\n  color: var(--color-dark);\n  margin-right: 1rem;\n}\n\n\n\n\n\n.--block {\n  display: block;\n}\n.--inline-block {\n  display: inline-block;\n}\n\n.--width-100 {\n  width: 100%;\n}\n\n.--width-500px {\n  width: 500px;\n}\n\n.--line {\n  position: relative;\n}\n.--line::after {\n  content: \"\";\n  position: absolute;\n  left: 50%;\n  bottom: -5px;\n  transform: translateX(-50%);\n  width: 5rem;\n  height: 3px;\n  margin-bottom: 1rem;\n\n  background: rgb(217, 8, 170);\n  background: linear-gradient(\n    135deg,\n    rgba(163, 1, 191, 1) 44%,\n    rgba(217, 8, 170, 1) 57%\n  );\n}\n\n.--list-style-none {\n  list-style: none;\n}\n\n.--profile-img {\n  width: 6rem;\n  height: 6rem;\n  border: 1px solid #ccc;\n  border-radius: 50%;\n}\n\n/* a {\n  font-size: 1rem;\n  color: #0F0F0F;\n  text-decoration: none;\n  transition: all 0.2s;\n} */\n\n@font-face {\n  font-family: daxplinepro;\n  src: url(../Assets/fonts/Dax-Pro-Regular.ttf);\n}\n\n/* a:hover {\n  color: var(--color-dark);\n  font-size: 1.5rem;\n} */\n\n/* Start here */\n.products {\n  background-color: var(--dark--green);\n  background-image: url(../Assets/Images/aboutus-hreo-bg.svg);\n  height: 100%;\n  background-repeat: no-repeat;\n  background-size: cover;\n  background-position: 80% 26%;\n  padding: 4rem 4rem 0rem 4rem;\n  /* position: relative;\n  z-index: -1; */\n}\n\n\n.overlay {\n  position: fixed;\n  width: 100%;\n  height: 100%;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: -1;\n  background-color: rgba(1, 34, 9, 0.641);\n}\n\n.products p {\n  color: var(--primary-orange);\n  font-size: 0.9rem;\n}\n\n.ourProducts h3 {\n  font-size: 3.5rem;\n}\n.ourProducts {\n  display: flex;\n  justify-content: space-between;\n}\n.ourProducts h6 {\n  font-size: 1.5rem;\n  width: 50%;\n}\n.ourProducts span {\n  display: block;\n}\n\n.card {\n  font-family: daxplinepro;\n  background-color: var(--primary-green);\n  border-radius: 0.7rem;\n  padding: 6rem 4rem;\n  color: var(--color-white);\n  margin: 2rem;\n  /* margin-left: 4rem; */\n  /* width: 90%; */\n}\n\n.paragraph p {\n  font-size: 1.5rem;\n  font-weight: 200;\n  color: white;\n  text-align: center;\n  padding: 2rem;\n}\n\n.paragraph span {\n  display: block;\n}\n/* projects and products */\n.projects {\n  \n  padding: 4rem 2rem;\n  color: var(--color-white);\n  font-size: 1.3rem;\n  gap: 30px;\n}\n.adverse {\n  background-color: #0fdc0f;\n  color: black;\n  display: flex;\n  justify-content: space-between;\n  border-radius: 2rem;\n  height: 222px;\n  /* z-index: 999; */\n}\n\n.logo {\n  z-index: 999;\n  width: 100;\n  margin-top: 1.5rem;\n  padding: 1rem;\n}\n.adversediv {\n  background-color: white;\n  width: 100%;\n  padding: 1rem;\n  border-radius: 1rem;\n}\n\n.adversediv_p{\n  height: 100px;\n  padding-top: 10px;\n  font-size: 14px !important;\n  font-weight: 400 !important;\n  line-height: 21px !important;\n  color: #000 !important;\n}\n\nbutton {\n  background-color: #0fdc0f;\n  padding: 1rem;\n  border: 1px solid transparent;\n  margin: 2rem 0rem;\n  color: white;\n  width: 80%;\n  border-radius: 2rem;\n  font-size: 1.5rem;\n  cursor: pointer;\n}\n\n/* APPRAISE CARD */\n.Appraise {\n  background-color: red;\n}\n\n/* VatDOc Card */\n.VatDoc {\n  background-color: var(--primary-orange);\n}\n/* VatDoc */\n.WeApprove {\n  background-color: red;\n}\n.ChargePlus {\n  background-color: var(--primary-orange);\n}\n.Verifyer {\n  background-color: var(--primary-orange);\n}\n.room {\n  background-color: var(--primary-orange);\n}\n\n/* Epertise Section */\n/* Epertise Section */\n/* Epertise Section */\n.expertise {\n  background-color: var(--dark--green);\n  width: 100%;\n  color: white;\n  height: auto !important;\n  /* padding: 2rem; */\n}\n.expertisecontainer {\n  display: flex;\n  color: white;\n  padding: 1rem;\n  gap: 6rem;\n}\n\n.expertiseparagraph {\n  width: 25% !important;\n  position: relative;\n  text-transform: capitalize;\n  margin-bottom: 1rem;\n\n}\n\n.expertiseparagraph p {\n  font-size: 1.2rem !important;\n}\n\n.expertiseparagraph h3{\n  font-size: 2.7rem !important;\n  margin-top: .8rem;\n  margin-bottom: 1.2rem;\n}\n.colors::after {\n  position: absolute;\n  content: \"\";\n  bottom: 40;\n  left: 0;\n  width: 65%;\n  border-radius: 2rem;\n  height: 1%;\n  background-image: linear-gradient(\n    to left,\n    #eaad11,\n    #d6b700,\n    #bec100,\n    #a1ca00,\n    #7dd200,\n    #7dd200,\n    #7dd200,\n    #7dd200,\n    #a1ca00,\n    #bec100,\n    #d6b700,\n    #eaad11\n  );\n}\n\n.professional {\n  display: flex;\n  gap: 2rem;\n}\n\n.tech2{\n font-size: 3rem;\n}\n.sketch{\n  width: 8%;\n  padding-right: .7rem;\n}\n.tech2 p{\n  color: white;\n  font-size: 1.5rem;\n  margin-top: 1rem;\n  flex-wrap: wrap;\n  margin-left: 4rem;\n\n}\n.tech2 p span {\n  display: block;\n}\n\n.lady_techie{\n  border-radius: 15px;\n}\n\n/* Mobile screens */\n@media screen and (max-width: 1050px) {\n\n  .adversediv_p{\n    height: 115px;\n    font-size: 12px !important;\n    line-height: 20px !important;\n  }\n\n  button {\n    width: 90%;\n  }\n\n  .expertisecontainer {\n    gap: 3rem;\n    \n  }\n\n  .expertiseparagraph {\n    width: 30% !important;\n  }\n\n  .expertiseparagraph h3{\n    font-size: 2.4rem !important;\n  }\n\n  .lady_techie{\n    width: 200px;\n    height: 350px;\n    object-fit: cover;\n    border-radius: 15px;\n  }\n\n  .man_techie{\n    width: 350px;\n  }\n\n}\n\n\n@media screen and (max-width: 900px) {\n  .--grid-25 {\n    display: grid;\n    grid-template-columns: repeat(2, 1fr);\n    justify-content: center;\n    align-items: center;\n  } \n  \n  .adversediv_p{\n    height: 110px;\n  }\n\n  .expertisecontainer {\n    gap: 1rem;\n    \n  }\n\n  .expertiseparagraph {\n    width: 35% !important;\n  }\n\n  .expertiseparagraph h3{\n    font-size: 2rem !important;\n  }\n\n  .lady_techie{\n    width: 150px;\n    height: 350px;\n  }\n\n  .man_techie{\n    width: 220px;\n  }\n\n  .tech2{\n    font-size: 1.6rem;\n   }\n   .sketch{\n     width: 13%;\n     padding-right: 0.8rem;\n     margin-top: 10px;\n   }\n\n   .sketch_span{\n    font-size: 20px!important;\n   }\n\n   .tech2 p{\n     color: white;\n     font-size: 1.5rem;\n     margin-top: 1rem;\n     flex-wrap: wrap;\n     margin-left: 2.6rem;\n   \n   }\n\n\n}\n\n\n@media screen and (max-width: 500px) {\n\n  .card {\n    padding: 6rem 2.5rem;\n  }\n\n  .products {\n    padding: 3rem 2rem;\n    background-position: center;\n  }\n\n  .ourProducts {\n    flex-direction: column;\n  }\n  .card{\n    margin-left: 0;\n    width: 100%;\n  }\n  .card p{\n    width: 100%;\n  }\n  \n  .ourProducts h3 {\n    width: 100%;\n    font-size: 2.7rem;\n    padding: 20px 0;\n  }\n  .ourProducts h6 {\n    width: 100%;\n    font-size: 1.3rem;\n  }\n\n  .projects{\n    padding: 1rem 0rem;\n  }\n\n  button {\n    padding: 0.8rem 0;\n  }\n\n  .adverse{\n    width: 100%;\n  }\n  \n\n  .--grid-25 {\n    display: grid;\n    grid-template-columns: repeat(1, 1fr);\n  }\n\n  .expertisecontainer{\n    flex-direction: column;\n   \n  }\n  .expertiseparagraph{\n    width: 100% !important;\n  }\n  \n  .expertiseparagraph h3 {\n    width: 100%;\n  }\n\n  .professional{\n    flex-direction: column;\n    align-items: center;\n    width: 100%;\n\n  }\n\n  .techie1{ \n    margin-top: 2rem;\n    width: 100%;\n    display: flex !important;\n  }\n\n\n  .lady_techie{\n    display: none !important;\n  }\n\n  .man_techie{\n    width: 100% !important;\n  }\n\n  .sketch{\n    display: inline-block !important;\n    width: 8% !important;\n  }\n \n  .adversediv{\n    padding: 1rem;\n  }\n\n  .colors::after{\n    height: 10%;\n    width: 75% !important;\n  }\n\n  .tech2 p{\n    margin-left: 3rem !important;\n    width: 280px !important;\n  }\n}\n\n@media screen and (max-width: 380px) {\n  .ourProducts h3 {\n    font-size: 2.5rem;\n  }\n  .ourProducts h6 {\n    font-size: 1.1rem;\n  }\n}\n\n@media screen and (max-width: 330px) {\n\n  .ourProducts h3 {\n    font-size: 2.3rem;\n  }\n  .ourProducts h6 {\n    font-size: 1rem;\n  }\n\n  .adversediv_p{\n    font-size: 12px !important;\n    font-weight: 400 !important;\n    line-height: 18px !important;\n    height: 120px;\n  }\n\n  button {\n    width: 90%;\n  }\n\n  .sketch{\n    /* display: inline-block !important; */\n    width: 10% !important;\n  }\n\n  .tech2 p{\n    margin-left: 3rem !important;\n    width: 220px !important;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
